<style lang="scss" src="./style.scss" scoped></style>

<template>
  <div
    :class="[
      'a-input',
      {
        '--disabled': disabled,
        '--has-error': error,
      },
    ]"
  >
    <label v-if="hasLabel" class="a-input__label">
      <slot></slot><span class="a-input__required" v-if="required">*</span>
    </label>
    <div class="a-dropdown" :class="{ '-open': isOpen }">
      <input type="hidden" :value="selectedValue" />
      <button
        type="button"
        class="a-dropdown__toggler"
        @click="isOpen = !isOpen"
      >
        <output>{{ selectedLabel }}</output>
        <svg
          class="a-dropdown__toggler-icon"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.7781 10L4 2.22187L6.22187 0L16.2219 10L6.22187 20L4 17.7781L11.7781 10Z"
          />
        </svg>
      </button>

      <ul v-if="isOpen" class="a-dropdown__content" tabindex="-1">
        <li
          v-for="option in options"
          class="a-dropdown__option"
          :key="option.value"
        >
          <button
            type="button"
            class="a-dropdown__option-button"
            @click="choose(option)"
          >
            {{ option.label }}
          </button>
        </li>
      </ul>
    </div>
    <span v-show="error" class="a-input__error">{{ error }}</span>
  </div>
</template>

<script lang="ts">
export default {
  name: 'Select',
  props: {
    options: {
      type: Array,
    },
    required: {
      type: Boolean,
      required: false,
    },
    error: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      isOpen: false,
      selectedValue: '',
      selectedLabel: 'Sélectionnez une valeur',
    };
  },
  methods: {
    choose({ value, label }) {
      this.selectedValue = value;
      this.selectedLabel = label;
      this.isOpen = false;

      this.$emit('input', value, label);
    },
  },
  computed: {
    hasLabel() {
      return !!this.$slots.default;
    },
  },
};
</script>
